import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WebConfigFuncionalidadeRotinaResponse } from '../models/webConfigFuncionalidadeRotinaResponse.model';

export class WebConfigFuncionalidadeRotinaService extends ApiService{

    private strAction = 'api/WebConfigFuncionalidadeRotina';
    dialogData: any;

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    RetornarPor(idPerfil: number, idPlano: number, idFuncionalidade: number): Observable<WebConfigFuncionalidadeRotinaResponse[]> {
        return this.get<WebConfigFuncionalidadeRotinaResponse[]>(this.strAction + `/RetornarPor?idCategoria=${idPerfil ? idPerfil : 0}&idPlano=${idPlano ? idPlano : 0}&idFuncionalidade=${idFuncionalidade ? idFuncionalidade : 0}`);
    }
    Inserir(webConfigFuncionalidadeRotina: WebConfigFuncionalidadeRotinaResponse): Observable<WebConfigFuncionalidadeRotinaResponse> {
        console.log(webConfigFuncionalidadeRotina)
        return this.post<WebConfigFuncionalidadeRotinaResponse>(this.strAction + `/Criar`, webConfigFuncionalidadeRotina);
    }
    RetornarTodos(): Observable<WebConfigFuncionalidadeRotinaResponse[]> {
        return this.get<WebConfigFuncionalidadeRotinaResponse[]>(this.strAction + `/GetAll`);
    }
    

    listInsertData(webConfigFuncionalidadeRotina: WebConfigFuncionalidadeRotinaResponse): void {
        this.dialogData = webConfigFuncionalidadeRotina;
    }

    listDeleteData(webConfigFuncionalidadeRotina: WebConfigFuncionalidadeRotinaResponse): void {
        this.dialogData = webConfigFuncionalidadeRotina;
    }

    getDialogData() {
        return this.dialogData;
    }
    Put(webConfigFuncionalidadeRotina: WebConfigFuncionalidadeRotinaResponse) {
        return this.post<WebConfigFuncionalidadeRotinaResponse>(this.strAction + `/Atualizar`, webConfigFuncionalidadeRotina);
    }
    listUpdateData(webConfigFuncionalidadeRotina: WebConfigFuncionalidadeRotinaResponse): void {
        this.dialogData = webConfigFuncionalidadeRotina;
    }
    deletar(idConfigFuncionalidadeRotina: number) {
        return this.post(this.strAction + `/DeleteById?id=${idConfigFuncionalidadeRotina}`);
    }
}